import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[ngxFiveDigitAlphanumeric]",
})
export class FiveDigitAlphanumericDirective {
  private readonly alphanumericPattern = /^[a-zA-Z0-9]{0,5}$/;

  constructor(private el: ElementRef) {}

  @HostListener("input", ["$event"])
  onInputChange(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;

    // Remove any non-alphanumeric characters
    if (!this.alphanumericPattern.test(value)) {
      value = value.replace(/[^a-zA-Z0-9]/g, "");
    }

    // Update the input value if it has changed
    input.value = value;
  }
}
